module.exports = require("@swa-ui/core/src/DateSelector/Month.module.scss");